import { vNodeMount } from './vNode.mount';
import { vNodeUnmount } from './vNode.unmount';
export const vNodeReplaceElement = (oldVNode, newVNode, container) => {
    if (oldVNode.type === 'ELEMENT') {
        oldVNode.lifeEvents.willUnmount?.(oldVNode._el);
        oldVNode.lifeEvents.willUnmount = undefined;
        oldVNode.children.forEach(vNodeUnmount);
    }
    vNodeMount({
        vNode: newVNode,
        oldEl: oldVNode._el,
        container
    });
    oldVNode._el = undefined;
    if (oldVNode.type === 'ELEMENT') {
        oldVNode.lifeEvents.didUnmount?.();
        oldVNode.lifeEvents.didUnmount = undefined;
    }
};
